import { is, getBusinessObject } from "bpmn-js/lib/util/ModelUtil";
import entryFactory from "bpmn-js-properties-panel/lib/factory/EntryFactory";
import cmdHelper from "bpmn-js-properties-panel/lib/helper/CmdHelper";
import elementHelper from "bpmn-js-properties-panel/lib/helper/ElementHelper";
import extensionElementsHelper from "bpmn-js-properties-panel/lib/helper/ExtensionElementsHelper";
import resultVariable from "bpmn-js-properties-panel/lib/provider/camunda/parts/implementation/ResultVariable";
import forEach from "lodash/forEach";
import React from "react";
import ReactDOM from "react-dom";

import ModelerModalGerarMinuta from "./modeler-modal-gerar-minuta";
import ModelerModalGerarPdfNew from "./modeler-modal-gerar-pdf-new";
import ModelerModalGerarXml from "./modeler-modal-gerar-xml";
import ModelerModalGerarPdfRegistrar from "./modeler-modal-gerar-pdf-registrar";
import ModelerModalGerarQrBarCode from "./modeler-modal-gerar-qr-bar-code";
import ModelerModalIntegrarApiManager from "./modeler-modal-integrar-api-manager";
import ModelerModalIntegrarAssinatura from "./modeler-modal-integrar-assinatura";
import ModelerModalIntegrarAssinaturaLote from "./modeler-modal-integrar-assinatura-lote";
import ModelerModalIntegrarAssinaturaLoteGetResult from "./modeler-modal-integrar-assinatura-lote-get-result";
import ModelerModalIntegrarDocz from "./modeler-modal-integrar-docz";
import ModelerModalIntegrarDoczEtiqueta from "./modeler-modal-integrar-docz-etiqueta";
import ModelerModalIntegrarDoczSesi from "./modeler-modal-integrar-docz-sesi";
import ModelerModalIntegrarSei from "./modeler-modal-integrar-sei";
import ModelerModalRegistrarArquivarDocumento from "./modeler-modal-registrar-arquivar-documento";
import ModelerModalRegistrarDocumento from "./modeler-modal-registrar-documento";
import {
  HTML,
  ECMDOCUMENTS,
  UPLOAD,
  DYNAMICTABLE,
  TYPOGRAPHY,
  IMAGE,
  BUTTON,
  GRID,
} from "../../../../../containers/smartForms/components/constants";
import Provider from "../../../../../Provider";
import {
  getScriptParameterByName,
  getUniqueTaskFields,
  convertToCamundaScriptValue,
  getUniqueDocumentServiceFields,
} from "../../../../../util/camundaPropertiesPanelUtils";

const attributeInfo = {
  bpmn: {
    element: "calledElement",
    binding: "camunda:calledElementBinding",
    version: "camunda:calledElementVersion",
    versionTag: "camunda:calledElementVersionTag",
    tenantId: "camunda:calledElementTenantId",
  },

  cmmn: {
    element: "camunda:caseRef",
    binding: "camunda:caseBinding",
    version: "camunda:caseVersion",
    tenantId: "camunda:caseTenantId",
  },

  dmn: {
    element: "camunda:decisionRef",
    binding: "camunda:decisionRefBinding",
    version: "camunda:decisionRefVersion",
    versionTag: "camunda:decisionRefVersionTag",
    tenantId: "camunda:decisionRefTenantId",
  },
};

const mapDecisionResultOptions = [
  {
    name: "singleEntry (TypedValue)",
    value: "singleEntry",
  },
  {
    name: "singleResult (Map<String, Object>)",
    value: "singleResult",
  },
  {
    name: "collectEntries (List<Object>)",
    value: "collectEntries",
  },
  {
    name: "resultList (List<Map<String, Object>>)",
    value: "resultList",
  },
];

const delegateVariableMappingOptions = [
  {
    name: "variableMappingClass",
    value: "variableMappingClass",
  },
  {
    name: "variableMappingDelegateExpression",
    value: "variableMappingDelegateExpression",
  },
];

const camposNaoPermitidos = [
  HTML,
  ECMDOCUMENTS,
  UPLOAD,
  DYNAMICTABLE,
  TYPOGRAPHY,
  IMAGE,
  BUTTON,
  GRID,
];

function getPropertiesElement(element) {
  let data = null;
  forEach(element.values, function (elem) {
    if (elem.$type === "camunda:FormData") {
      data = elem;
    }
  });
  return data;
}
function getDetailProps(fields, parentId) {
  const formfields = [];
  let ntype = null;
  let jsondata = {};

  forEach(fields, function (prop) {
    if (
      prop &&
      prop.properties &&
      prop.properties.values &&
      prop.properties.values[0] &&
      prop.properties.values[0].$attrs &&
      prop.properties.values[0].$attrs.smart
    ) {
      jsondata = JSON.parse(prop.properties.values[0].value);
      ntype = jsondata.type;
    } else {
      ntype = null;
      jsondata = {};
    }
    if (ntype === GRID) {
      const griddata = getGridDetails(jsondata, parentId);
      Array.prototype.push.apply(formfields, griddata);
    }

    const permitedField = camposNaoPermitidos.find(function (f) {
      if (f === ntype) {
        return true;
      }
      return false;
    });
    if (!permitedField) {
      const item = {
        id: prop.id,
        label: prop.label,
        parentId,
        type: ntype,
        data: jsondata,
      };
      formfields.push(item);
    }
  });
  return formfields;
}

function getGridDetails(fields, parentId) {
  const formfields = [];
  for (let linha = 0; linha < fields.items.length; linha++) {
    const rows = fields.items[linha];
    for (let column = 0; column < rows.items.length; column++) {
      const col = rows.items[column];

      for (let content = 0; content < col.items.length; content++) {
        const cont = col.items[content];

        const permitedField = camposNaoPermitidos.find(function (f) {
          if (f === cont.type) {
            return true;
          }
          return false;
        });
        if (!permitedField) {
          formfields.push({
            id: cont.id,
            label: cont.label,
            parentId,
          });
        }
      }
    }
  }
  return formfields;
}

function getTaskFields(elements, issub = false) {
  let formfields = [];
  let listTaskFields = [];
  const listexistFields = [];
  if (!issub) {
    listTaskFields = [];
  }
  forEach(elements, function (elem) {
    let data = null;
    if (elem.$type === "bpmn:StartEvent" || elem.$type === "bpmn:UserTask") {
      if (is(elem.extensionElements, "bpmn:ExtensionElements")) {
        data = getPropertiesElement(elem.extensionElements);
        listTaskFields = listTaskFields.concat(data.fields);

        if (data && data.fields && data.fields.length > 0) {
          const fields = getDetailProps(data.fields, elem.id);
          for (let i = 0; i < fields.length; i++) {
            // eslint-disable-next-line no-loop-func
            const existField = listexistFields.find(function (f) {
              if (f.id === fields[i].id) {
                return true;
              }
              return false;
            });
            // eslint-disable-next-line no-loop-func
            const permitedField = camposNaoPermitidos.find(function (f) {
              if (f === fields[i].type) {
                return true;
              }
              return false;
            });
            if (!existField && !permitedField) {
              formfields.push({
                activityName:
                  elem.name && elem.name.length > 0 ? elem.name : elem.id,
                id: elem.id,
                fieldId: fields[i].id,
              });
            }
          }
        }
      }
    } else if (elem.$type === "bpmn:SubProcess") {
      const SubProcess = getTaskFields(elem.flowElements, true);
      formfields = formfields.concat(SubProcess);
    }
  });

  return formfields;
}

function BuildRegistrarDocumentoBuildModal(
  itens,
  elementdom,
  saveRegistrarDocumentoConfig,
  element,
  bpmnFactory,
  extensionElements,
  businessObject,
  inputValues,
) {
  ReactDOM.render(
    <Provider>
      <ModelerModalRegistrarDocumento
        FormComponents={itens}
        saveRegistrarDocumentoConfig={saveRegistrarDocumentoConfig}
        element={element}
        extensionElements={extensionElements}
        bpmnFactory={bpmnFactory}
        businessObject={businessObject}
        inputValues={inputValues}
      />
    </Provider>,
    elementdom,
  );
}
function BuildGerarPdfRegistrarBuildModal(
  itens,
  elementdom,
  saveGerarPdfRegistrarConfig,
  element,
  bpmnFactory,
  extensionElements,
  businessObject,
  inputValues,
) {
  ReactDOM.render(
    <Provider>
      <ModelerModalGerarPdfRegistrar
        FormComponents={itens}
        saveGerarPdfRegistrarConfig={saveGerarPdfRegistrarConfig}
        element={element}
        extensionElements={extensionElements}
        bpmnFactory={bpmnFactory}
        businessObject={businessObject}
        inputValues={inputValues}
      />
    </Provider>,
    elementdom,
  );
}

function BuildGerarMinutaBuildModal(
  itens,
  elementdom,
  saveGerarMinutaConfig,
  element,
  bpmnFactory,
  extensionElements,
  businessObject,
  inputValues,
) {
  ReactDOM.render(
    <Provider>
      <ModelerModalGerarMinuta
        FormComponents={itens}
        saveGerarMinutaConfig={saveGerarMinutaConfig}
        element={element}
        extensionElements={extensionElements}
        bpmnFactory={bpmnFactory}
        businessObject={businessObject}
        inputValues={inputValues}
      />
    </Provider>,
    elementdom,
  );
}

function BuildRegistrarArquivarDocumentoModal(
  itens,
  elementdom,
  saveRegistrarArquivarDocumentoConfig,
  element,
  bpmnFactory,
  extensionElements,
  businessObject,
  inputValues,
) {
  ReactDOM.render(
    <Provider>
      <ModelerModalRegistrarArquivarDocumento
        FormComponents={itens}
        saveRegistrarArquivarDocumentoConfig={
          saveRegistrarArquivarDocumentoConfig
        }
        element={element}
        extensionElements={extensionElements}
        bpmnFactory={bpmnFactory}
        businessObject={businessObject}
        inputValues={inputValues}
      />
    </Provider>,
    elementdom,
  );
}

function BuildGerarPdfNewModal(
  itens,
  elementdom,
  saveGerarPdfNewConfig,
  element,
  bpmnFactory,
  extensionElements,
  businessObject,
  inputValues,
) {
  ReactDOM.render(
    <Provider>
      <ModelerModalGerarPdfNew
        FormComponents={itens}
        saveGerarPdfNewConfig={saveGerarPdfNewConfig}
        element={element}
        extensionElements={extensionElements}
        bpmnFactory={bpmnFactory}
        businessObject={businessObject}
        inputValues={inputValues}
      />
    </Provider>,
    elementdom,
  );
}

function BuildGerarXmlModal(
  itens,
  elementdom,
  saveGerarXmlConfig,
  element,
  bpmnFactory,
  extensionElements,
  businessObject,
  inputValues,
) {
  ReactDOM.render(
    <Provider>
      <ModelerModalGerarXml
        FormComponents={itens}
        saveGerarXmlConfig={saveGerarXmlConfig}
        element={element}
        extensionElements={extensionElements}
        bpmnFactory={bpmnFactory}
        businessObject={businessObject}
        inputValues={inputValues}
      />
    </Provider>,
    elementdom,
  );
}

function BuildIntegrarDoczEtiquetaModal(
  itens,
  elementdom,
  saveIntegrarDoczEtiquetaConfig,
  element,
  bpmnFactory,
  extensionElements,
  businessObject,
  inputValues,
) {
  ReactDOM.render(
    <Provider>
      <ModelerModalIntegrarDoczEtiqueta
        FormComponents={itens}
        saveIntegrarDoczEtiquetaConfig={saveIntegrarDoczEtiquetaConfig}
        element={element}
        extensionElements={extensionElements}
        bpmnFactory={bpmnFactory}
        businessObject={businessObject}
        inputValues={inputValues}
      />
    </Provider>,
    elementdom,
  );
}

function BuildIntegrarDoczModal(
  itens,
  elementdom,
  saveIntegrarDoczConfig,
  element,
  bpmnFactory,
  extensionElements,
  businessObject,
  inputValues,
) {
  ReactDOM.render(
    <Provider>
      <ModelerModalIntegrarDocz
        FormComponents={itens}
        saveIntegrarDoczConfig={saveIntegrarDoczConfig}
        element={element}
        extensionElements={extensionElements}
        bpmnFactory={bpmnFactory}
        businessObject={businessObject}
        inputValues={inputValues}
      />
    </Provider>,
    elementdom,
  );
}

function BuildIntegrarDoczSesiModal(
  itens,
  elementdom,
  saveIntegrarDoczSesiConfig,
  element,
  bpmnFactory,
  extensionElements,
  businessObject,
  inputValues,
) {
  ReactDOM.render(
    <Provider>
      <ModelerModalIntegrarDoczSesi
        FormComponents={itens}
        saveIntegrarDoczSesiConfig={saveIntegrarDoczSesiConfig}
        element={element}
        extensionElements={extensionElements}
        bpmnFactory={bpmnFactory}
        businessObject={businessObject}
        inputValues={inputValues}
      />
    </Provider>,
    elementdom,
  );
}

function BuildIntegrarSeiModal(
  itens,
  elementdom,
  saveIntegrarSeiConfig,
  element,
  bpmnFactory,
  extensionElements,
  businessObject,
  inputValues,
) {
  ReactDOM.render(
    <Provider>
      <ModelerModalIntegrarSei
        FormComponents={itens}
        saveIntegrarSeiConfig={saveIntegrarSeiConfig}
        element={element}
        extensionElements={extensionElements}
        bpmnFactory={bpmnFactory}
        businessObject={businessObject}
        inputValues={inputValues}
      />
    </Provider>,
    elementdom,
  );
}

function BuildIntegrarAssinaturaModal(
  itens,
  elementdom,
  saveIntegrarAssinaturaConfig,
  element,
  bpmnFactory,
  extensionElements,
  businessObject,
  inputValues,
) {
  ReactDOM.render(
    <Provider>
      <ModelerModalIntegrarAssinatura
        FormComponents={itens}
        saveIntegrarAssinaturaConfig={saveIntegrarAssinaturaConfig}
        element={element}
        extensionElements={extensionElements}
        bpmnFactory={bpmnFactory}
        businessObject={businessObject}
        inputValues={inputValues}
      />
    </Provider>,
    elementdom,
  );
}

function BuildIntegrarAssinaturaLoteModal(
  itens,
  elementdom,
  saveIntegrarAssinaturaLoteConfig,
  element,
  bpmnFactory,
  extensionElements,
  businessObject,
  inputValues,
) {
  ReactDOM.render(
    <Provider>
      <ModelerModalIntegrarAssinaturaLote
        FormComponents={itens}
        saveIntegrarAssinaturaLoteConfig={saveIntegrarAssinaturaLoteConfig}
        element={element}
        extensionElements={extensionElements}
        bpmnFactory={bpmnFactory}
        businessObject={businessObject}
        inputValues={inputValues}
      />
    </Provider>,
    elementdom,
  );
}

function BuildIntegrarAssinaturaLoteGetResultModal(
  itens,
  elementdom,
  saveIntegrarAssinaturaLoteGetResultConfig,
  element,
  bpmnFactory,
  extensionElements,
  businessObject,
  inputValues,
) {
  ReactDOM.render(
    <Provider>
      <ModelerModalIntegrarAssinaturaLoteGetResult
        FormComponents={itens}
        saveIntegrarAssinaturaLoteGetResultConfig={
          saveIntegrarAssinaturaLoteGetResultConfig
        }
        element={element}
        extensionElements={extensionElements}
        bpmnFactory={bpmnFactory}
        businessObject={businessObject}
        inputValues={inputValues}
      />
    </Provider>,
    elementdom,
  );
}

function BuildIntegrarApiManagerModal(
  itens,
  elementdom,
  saveIntegrarApiManagerConfig,
  element,
  bpmnFactory,
  extensionElements,
  businessObject,
  inputValues,
) {
  ReactDOM.render(
    <Provider>
      <ModelerModalIntegrarApiManager
        FormComponents={itens}
        saveIntegrarApiManagerConfig={saveIntegrarApiManagerConfig}
        element={element}
        extensionElements={extensionElements}
        bpmnFactory={bpmnFactory}
        businessObject={businessObject}
        inputValues={inputValues}
      />
    </Provider>,
    elementdom,
  );
}

function BuildGerarQrBarCodeModal(
  itens,
  elementdom,
  saveGerarQrBarCodeConfig,
  element,
  bpmnFactory,
  extensionElements,
  businessObject,
  inputValues,
) {
  ReactDOM.render(
    <Provider>
      <ModelerModalGerarQrBarCode
        FormComponents={itens}
        saveGerarQrBarCodeConfig={saveGerarQrBarCodeConfig}
        element={element}
        extensionElements={extensionElements}
        bpmnFactory={bpmnFactory}
        businessObject={businessObject}
        inputValues={inputValues}
      />
    </Provider>,
    elementdom,
  );
}

function getCamundaInWithBusinessKey(element) {
  const camundaIn = [],
    bo = getBusinessObject(element);

  const camundaInParams = extensionElementsHelper.getExtensionElements(
    bo,
    "camunda:In",
  );
  if (camundaInParams) {
    forEach(camundaInParams, function (param) {
      if (param.businessKey !== undefined) {
        camundaIn.push(param);
      }
    });
  }
  return camundaIn;
}

function setBusinessKey(element, text, bpmnFactory) {
  const commands = [];

  const camundaInWithBusinessKey = getCamundaInWithBusinessKey(element);

  if (camundaInWithBusinessKey.length) {
    commands.push(
      cmdHelper.updateBusinessObject(element, camundaInWithBusinessKey[0], {
        businessKey: text,
      }),
    );
  } else {
    const bo = getBusinessObject(element);
    let extensionElements = bo.extensionElements;

    if (!extensionElements) {
      extensionElements = elementHelper.createElement(
        "bpmn:ExtensionElements",
        { values: [] },
        bo,
        bpmnFactory,
      );
      commands.push(
        cmdHelper.updateProperties(element, {
          extensionElements,
        }),
      );
    }

    const camundaIn = elementHelper.createElement(
      "camunda:In",
      { businessKey: text },
      extensionElements,
      bpmnFactory,
    );

    commands.push(
      cmdHelper.addAndRemoveElementsFromList(
        element,
        extensionElements,
        "values",
        "extensionElements",
        [camundaIn],
        [],
      ),
    );
  }

  return commands;
}

function deleteBusinessKey(element) {
  const camundaInExtensions = getCamundaInWithBusinessKey(element);
  const commands = [];
  forEach(camundaInExtensions, function (elem) {
    commands.push(
      extensionElementsHelper.removeEntry(
        getBusinessObject(element),
        element,
        elem,
      ),
    );
  });
  return commands;
}

function isSupportedCallableType(type) {
  return ["bpmn", "cmmn", "dmn", "smartrules"].indexOf(type) !== -1;
}

function parseSmartRule(data, type) {
  let returnData = {};

  if (type === "OUT") {
    returnData = {
      project: data.project,
      rule: data.rule,
      inputObject: data.inputObject,
      properties: [
        {
          id: "mappedFields",
          text: "mappedFields",
          type: "object",
          value: data.properties.mappedFields,
        },
        {
          id: "outputMappedFields",
          text: "outputMappedFields",
          type: "object",
          value: data.properties.outputMappedFields,
        },
      ],
    };
  } else {
    returnData = {
      project: data.project,
      rule: data.rule,
      inputObject: data.inputObject,
      properties: {
        mappedFields: data.properties[0].value,
        outputMappedFields: data.properties[1].value,
      },
    };
  }
  return returnData;
}

function readRegistrarDocumentoFromModeler(inputParameters) {
  const returnData = {
    metadados: [],
    fileList: [],
    parentFolder: null,
    parentFolderTemplateName: [],
    parentFolderNameTemp: "",
  };

  if (inputParameters) {
    inputParameters.forEach((item, index) => {
      if (item) {
        if (item.name === "metadados") {
          try {
            returnData.metadados = JSON.parse(item.value);
          } catch (err) {
            /* empty */
          }
        } else if (item.name === "fileList") {
          if (item.value) {
            try {
              returnData.fileList = JSON.parse(item.value);
            } catch (err) {
              /* empty */
            }
          }
        } else if (item.name === "parentFolderTemplateName") {
          if (item.value) {
            returnData.parentFolderTemplateName = item.value
              .split(" ")
              .map((p) => p.replace("#", ""));
          }
        } else {
          returnData[item.name] = item.value;
        }
      }
    });
  }

  return returnData;
}
function readGerarPdfRegistrarFromModeler(inputParameters) {
  const returnData = {
    metadados: [],
    parentFolder: null,
    template: "",
    documentType: "",
    titulo: "",
    parentFolderTemplateName: [],
    parentFolderNameTemp: "",
  };

  if (inputParameters) {
    inputParameters.forEach((item, index) => {
      if (item) {
        if (item.name === "metadados") {
          try {
            returnData.metadados = JSON.parse(item.value);
          } catch (err) {
            /* empty */
          }
        } else if (item.name === "parentFolderTemplateName") {
          if (item.value) {
            returnData.parentFolderTemplateName = item.value
              .split(" ")
              .map((p) => p.replace("#", ""));
          }
        } else {
          returnData[item.name] = item.value;
        }
      }
    });
  }

  return returnData;
}

function readGerarMinutaFromModeler(inputParameters) {
  const returnData = {
    metadados: [],
    fileList: [],
    parentFolder: null,
    parentFolderTemplateName: [],
    parentFolderNameTemp: "",
  };

  if (inputParameters) {
    inputParameters.forEach((item, index) => {
      if (item) {
        if (item.name === "metadados") {
          try {
            returnData.metadados = JSON.parse(item.value);
          } catch (err) {
            /* empty */
          }
        } else if (item.name === "fileList") {
          if (item.value) {
            try {
              returnData.fileList = JSON.parse(item.value);
            } catch (err) {
              /* empty */
            }
          }
        } else if (item.name === "parentFolderTemplateName") {
          if (item.value) {
            returnData.parentFolderTemplateName = item.value
              .split(" ")
              .map((p) => p.replace("#", ""));
          }
        } else {
          returnData[item.name] = item.value;
        }
      }
    });
  }

  return returnData;
}

export default function (element, bpmnFactory, options, translate, modeling) {
  const bindingOptions = [
    {
      name: translate("latest"),
      value: "latest",
    },
    {
      name: translate("deployment"),
      value: "deployment",
    },
    {
      name: translate("version"),
      value: "version",
    },
    {
      name: translate("versionTag"),
      value: "versionTag",
    },
  ];

  const getCallableType = options.getCallableType;

  let entries = [];

  // eslint-disable-next-line no-unused-vars
  const saveConfig = function (
    businessObject,
    element,
    extensionElements,
    bpmnFactory,
    values,
  ) {
    const bo = getBusinessObject(element);
    extensionElements = bo.get("extensionElements");
    let AddExtension = false;
    let inputOutput = null;
    if (!extensionElements) {
      AddExtension = true;
      extensionElements = elementHelper.createElement(
        "bpmn:ExtensionElements",
        {},
        businessObject,
        bpmnFactory,
      );
      inputOutput = elementHelper.createElement(
        "camunda:InputOutput",
        {},
        extensionElements,
        bpmnFactory,
      );
    } else {
      inputOutput = extensionElements.values.find(function (elem) {
        if (elem.$type === "camunda:InputOutput") {
          return true;
        }
        return false;
      });
      if (inputOutput.inputParameters === undefined) {
        inputOutput.set("inputParameters", []);
      }
    }

    const InputParameter = elementHelper.createElement(
      "camunda:InputParameter",
      {
        name: "ruleFields",
        value: JSON.stringify(parseSmartRule(values, "OUT")),
      },
      inputOutput,
      bpmnFactory,
    );

    inputOutput.set("inputParameters", [InputParameter]);
    if (AddExtension) {
      extensionElements.set("values", [inputOutput]);
      bo.set("extensionElements", extensionElements);
    }

    modeling.updateProperties(element, {});
  };

  const saveRegistrarDocumentoConfig = function (
    businessObject,
    element,
    extensionElements,
    bpmnFactory,
    values,
  ) {
    const bo = getBusinessObject(element);
    extensionElements = bo.get("extensionElements");
    let AddExtension = false;
    let inputOutput = null;
    if (!extensionElements) {
      AddExtension = true;
      extensionElements = elementHelper.createElement(
        "bpmn:ExtensionElements",
        {},
        businessObject,
        bpmnFactory,
      );
      inputOutput = elementHelper.createElement(
        "camunda:InputOutput",
        {},
        extensionElements,
        bpmnFactory,
      );
    } else {
      inputOutput = extensionElements.values.find(function (elem) {
        if (elem.$type === "camunda:InputOutput") {
          return true;
        }
        return false;
      });
      if (inputOutput.inputParameters === undefined) {
        inputOutput.set("inputParameters", []);
      }
    }

    //alterando a variavel parentFolderTemplateName
    const parentFolderTemplateNameAux =
      (values.parentFolderTemplateName &&
        values.parentFolderTemplateName
          .reduce((acumulator, currentValue) => {
            return (acumulator += "#" + currentValue + " ");
          }, "")
          .trimEnd()) ||
      "";

    //salvando variaveis nos parametros de entrada
    const parentFolderInputParameter = elementHelper.createElement(
      "camunda:InputParameter",
      { name: "parentFolder", value: String(values.parentFolder) },
      inputOutput,
      bpmnFactory,
    );
    const parentFolderTemplateNameInputParameter = elementHelper.createElement(
      "camunda:InputParameter",
      { name: "parentFolderTemplateName", value: parentFolderTemplateNameAux },
      inputOutput,
      bpmnFactory,
    );
    const fileListInputParameter = elementHelper.createElement(
      "camunda:InputParameter",
      { name: "fileList", value: JSON.stringify(values.fileList) },
      inputOutput,
      bpmnFactory,
    );
    const metadadosInputParameter = elementHelper.createElement(
      "camunda:InputParameter",
      { name: "metadados", value: JSON.stringify(values.metadados) },
      inputOutput,
      bpmnFactory,
    );
    const parentFolderNameTempInputParameter = elementHelper.createElement(
      "camunda:InputParameter",
      {
        name: "parentFolderNameTemp",
        value: String(values.parentFolderNameTemp),
      },
      inputOutput,
      bpmnFactory,
    );

    //
    const inputParameters = [
      parentFolderInputParameter,
      parentFolderTemplateNameInputParameter,
      fileListInputParameter,
      metadadosInputParameter,
      parentFolderNameTempInputParameter,
    ];

    inputOutput.set("inputParameters", inputParameters);

    if (AddExtension) {
      extensionElements.set("values", [inputOutput]);
      bo.set("extensionElements", extensionElements);
    }

    modeling.updateProperties(element, {});
  };

  const saveGerarPdfRegistrarConfig = function (
    businessObject,
    element,
    extensionElements,
    bpmnFactory,
    values,
  ) {
    const bo = getBusinessObject(element);
    extensionElements = bo.get("extensionElements");
    let AddExtension = false;
    let inputOutput = null;
    if (!extensionElements) {
      AddExtension = true;
      extensionElements = elementHelper.createElement(
        "bpmn:ExtensionElements",
        {},
        businessObject,
        bpmnFactory,
      );
      inputOutput = elementHelper.createElement(
        "camunda:InputOutput",
        {},
        extensionElements,
        bpmnFactory,
      );
    } else {
      inputOutput = extensionElements.values.find(function (elem) {
        if (elem.$type === "camunda:InputOutput") {
          return true;
        }
        return false;
      });
      if (inputOutput.inputParameters === undefined) {
        inputOutput.set("inputParameters", []);
      }
    }

    //alterando a variavel parentFolderTemplateName
    const parentFolderTemplateNameAux =
      (values.parentFolderTemplateName &&
        values.parentFolderTemplateName
          .reduce((acumulator, currentValue) => {
            return (acumulator += "#" + currentValue + " ");
          }, "")
          .trimEnd()) ||
      "";

    //salvando variaveis nos parametros de entrada
    const templateInputParameter = elementHelper.createElement(
      "camunda:InputParameter",
      { name: "template", value: String(values.template) },
      inputOutput,
      bpmnFactory,
    );
    const documentTypeInputParameter = elementHelper.createElement(
      "camunda:InputParameter",
      { name: "documentType", value: String(values.documentType) },
      inputOutput,
      bpmnFactory,
    );
    const tituloInputParameter = elementHelper.createElement(
      "camunda:InputParameter",
      { name: "titulo", value: String(values.titulo) },
      inputOutput,
      bpmnFactory,
    );
    const parentFolderNameTempInputParameter = elementHelper.createElement(
      "camunda:InputParameter",
      {
        name: "parentFolderNameTemp",
        value: String(values.parentFolderNameTemp),
      },
      inputOutput,
      bpmnFactory,
    );
    const parentFolderInputParameter = elementHelper.createElement(
      "camunda:InputParameter",
      { name: "parentFolder", value: String(values.parentFolder) },
      inputOutput,
      bpmnFactory,
    );
    const parentFolderTemplateNameInputParameter = elementHelper.createElement(
      "camunda:InputParameter",
      { name: "parentFolderTemplateName", value: parentFolderTemplateNameAux },
      inputOutput,
      bpmnFactory,
    );
    const metadadosInputParameter = elementHelper.createElement(
      "camunda:InputParameter",
      { name: "metadados", value: JSON.stringify(values.metadados) },
      inputOutput,
      bpmnFactory,
    );

    //
    const inputParameters = [
      templateInputParameter,
      documentTypeInputParameter,
      tituloInputParameter,
      parentFolderNameTempInputParameter,
      parentFolderInputParameter,
      parentFolderTemplateNameInputParameter,
      metadadosInputParameter,
    ];

    inputOutput.set("inputParameters", inputParameters);

    if (AddExtension) {
      extensionElements.set("values", [inputOutput]);
      bo.set("extensionElements", extensionElements);
    }

    modeling.updateProperties(element, {});
  };

  const saveGerarMinutaConfig = function (
    businessObject,
    element,
    extensionElements,
    bpmnFactory,
    values,
  ) {
    const bo = getBusinessObject(element);
    extensionElements = bo.get("extensionElements");
    let AddExtension = false;
    let inputOutput = null;
    if (!extensionElements) {
      AddExtension = true;
      extensionElements = elementHelper.createElement(
        "bpmn:ExtensionElements",
        {},
        businessObject,
        bpmnFactory,
      );
      inputOutput = elementHelper.createElement(
        "camunda:InputOutput",
        {},
        extensionElements,
        bpmnFactory,
      );
    } else {
      inputOutput = extensionElements.values.find(function (elem) {
        if (elem.$type === "camunda:InputOutput") {
          return true;
        }
        return false;
      });
      if (inputOutput.inputParameters === undefined) {
        inputOutput.set("inputParameters", []);
      }
    }

    //alterando a variavel parentFolderTemplateName
    const parentFolderTemplateNameAux =
      (values.parentFolderTemplateName &&
        values.parentFolderTemplateName
          .reduce((acumulator, currentValue) => {
            return (acumulator += "#" + currentValue + " ");
          }, "")
          .trimEnd()) ||
      "";

    //salvando variaveis nos parametros de entrada
    const parentFolderInputParameter = elementHelper.createElement(
      "camunda:InputParameter",
      { name: "parentFolder", value: String(values.parentFolder) },
      inputOutput,
      bpmnFactory,
    );
    const parentFolderTemplateNameInputParameter = elementHelper.createElement(
      "camunda:InputParameter",
      { name: "parentFolderTemplateName", value: parentFolderTemplateNameAux },
      inputOutput,
      bpmnFactory,
    );
    const fileListInputParameter = elementHelper.createElement(
      "camunda:InputParameter",
      { name: "fileList", value: JSON.stringify(values.fileList) },
      inputOutput,
      bpmnFactory,
    );
    const metadadosInputParameter = elementHelper.createElement(
      "camunda:InputParameter",
      { name: "metadados", value: JSON.stringify(values.metadados) },
      inputOutput,
      bpmnFactory,
    );
    const parentFolderNameTempInputParameter = elementHelper.createElement(
      "camunda:InputParameter",
      {
        name: "parentFolderNameTemp",
        value: String(values.parentFolderNameTemp),
      },
      inputOutput,
      bpmnFactory,
    );
    //
    const inputParameters = [
      parentFolderInputParameter,
      parentFolderTemplateNameInputParameter,
      fileListInputParameter,
      metadadosInputParameter,
      parentFolderNameTempInputParameter,
    ];

    inputOutput.set("inputParameters", inputParameters);

    if (AddExtension) {
      extensionElements.set("values", [inputOutput]);
      bo.set("extensionElements", extensionElements);
    }

    modeling.updateProperties(element, {});
  };

  const saveRegistrarArquivarDocumentoConfig = function (
    businessObject,
    element,
    extensionElements,
    bpmnFactory,
    values,
  ) {
    const bo = getBusinessObject(element);
    extensionElements = bo.get("extensionElements");
    let AddExtension = false;
    let inputOutput = null;

    if (!extensionElements) {
      AddExtension = true;
      extensionElements = elementHelper.createElement(
        "bpmn:ExtensionElements",
        {},
        businessObject,
        bpmnFactory,
      );
      inputOutput = elementHelper.createElement(
        "camunda:InputOutput",
        {},
        extensionElements,
        bpmnFactory,
      );
    } else {
      inputOutput = extensionElements.values.find(function (elem) {
        if (elem.$type === "camunda:InputOutput") {
          return true;
        }
        return false;
      });
      if (inputOutput.inputParameters === undefined) {
        inputOutput.set("inputParameters", []);
      }
    }

    const registrarArquivarConfigInputParameter = elementHelper.createElement(
      "camunda:InputParameter",
      { name: "registrarDocumentoWithPathConfig" },
      inputOutput,
      bpmnFactory,
    );

    const registrarDocumentoWithPathConfigScript = elementHelper.createElement(
      "camunda:Script",
      {
        scriptFormat: "JavaScript",
        value: convertToCamundaScriptValue(JSON.stringify(values)),
      },
      registrarArquivarConfigInputParameter,
      bpmnFactory,
    );

    registrarArquivarConfigInputParameter.set(
      "definition",
      registrarDocumentoWithPathConfigScript,
    );

    inputOutput.set("inputParameters", [registrarArquivarConfigInputParameter]);
    if (AddExtension) {
      extensionElements.set("values", [inputOutput]);
      bo.set("extensionElements", extensionElements);
    }
    modeling.updateProperties(element, {});
  };

  const saveGerarPdfNewConfig = function (
    businessObject,
    element,
    extensionElements,
    bpmnFactory,
    values,
  ) {
    const bo = getBusinessObject(element);
    extensionElements = bo.get("extensionElements");
    let AddExtension = false;
    let inputOutput = null;

    if (!extensionElements) {
      AddExtension = true;
      extensionElements = elementHelper.createElement(
        "bpmn:ExtensionElements",
        {},
        businessObject,
        bpmnFactory,
      );
      inputOutput = elementHelper.createElement(
        "camunda:InputOutput",
        {},
        extensionElements,
        bpmnFactory,
      );
    } else {
      inputOutput = extensionElements.values.find(function (elem) {
        if (elem.$type === "camunda:InputOutput") {
          return true;
        }
        return false;
      });
      if (inputOutput.inputParameters === undefined) {
        inputOutput.set("inputParameters", []);
      }
    }

    const gerarPdfConfigInputParameter = elementHelper.createElement(
      "camunda:InputParameter",
      { name: "generatePdfFromTemplateWithPathConfig" },
      inputOutput,
      bpmnFactory,
    );

    const gerarPdfWithPathConfigScript = elementHelper.createElement(
      "camunda:Script",
      {
        scriptFormat: "JavaScript",
        value: convertToCamundaScriptValue(JSON.stringify(values)),
      },
      gerarPdfConfigInputParameter,
      bpmnFactory,
    );

    gerarPdfConfigInputParameter.set(
      "definition",
      gerarPdfWithPathConfigScript,
    );

    inputOutput.set("inputParameters", [gerarPdfConfigInputParameter]);
    if (AddExtension) {
      extensionElements.set("values", [inputOutput]);
      bo.set("extensionElements", extensionElements);
    }
    modeling.updateProperties(element, {});
  };

  const saveGerarXmlConfig = function (
    businessObject,
    element,
    extensionElements,
    bpmnFactory,
    values,
  ) {
    const bo = getBusinessObject(element);
    extensionElements = bo.get("extensionElements");
    let AddExtension = false;
    let inputOutput = null;

    if (!extensionElements) {
      AddExtension = true;
      extensionElements = elementHelper.createElement(
        "bpmn:ExtensionElements",
        {},
        businessObject,
        bpmnFactory,
      );
      inputOutput = elementHelper.createElement(
        "camunda:InputOutput",
        {},
        extensionElements,
        bpmnFactory,
      );
    } else {
      inputOutput = extensionElements.values.find(function (elem) {
        if (elem.$type === "camunda:InputOutput") {
          return true;
        }
        return false;
      });
      if (!inputOutput) {
        inputOutput = elementHelper.createElement(
          "camunda:InputOutput",
          {},
          extensionElements,
          bpmnFactory,
        );
        extensionElements.values.push(inputOutput);
      }
      if (inputOutput.inputParameters === undefined) {
        inputOutput.set("inputParameters", []);
      }
    }

    const gerarXmlConfigInputParameter = elementHelper.createElement(
      "camunda:InputParameter",
      { name: "generateXmlFromTemplateConfig" },
      inputOutput,
      bpmnFactory,
    );

    const gerarXmlWithPathConfigScript = elementHelper.createElement(
      "camunda:Script",
      {
        scriptFormat: "JavaScript",
        value: convertToCamundaScriptValue(JSON.stringify(values)),
      },
      gerarXmlConfigInputParameter,
      bpmnFactory,
    );

    gerarXmlConfigInputParameter.set(
      "definition",
      gerarXmlWithPathConfigScript,
    );

    inputOutput.set("inputParameters", [gerarXmlConfigInputParameter]);
    if (AddExtension) {
      extensionElements.set("values", [inputOutput]);
      bo.set("extensionElements", extensionElements);
    }
    modeling.updateProperties(element, {});
  };

  const saveIntegrarDoczConfig = function (
    businessObject,
    element,
    extensionElements,
    bpmnFactory,
    values,
  ) {
    const bo = getBusinessObject(element);
    extensionElements = bo.get("extensionElements");
    let AddExtension = false;
    let inputOutput = null;

    if (!extensionElements) {
      AddExtension = true;
      extensionElements = elementHelper.createElement(
        "bpmn:ExtensionElements",
        {},
        businessObject,
        bpmnFactory,
      );
      inputOutput = elementHelper.createElement(
        "camunda:InputOutput",
        {},
        extensionElements,
        bpmnFactory,
      );
    } else {
      inputOutput = extensionElements.values.find(function (elem) {
        if (elem.$type === "camunda:InputOutput") {
          return true;
        }
        return false;
      });
      if (inputOutput.inputParameters === undefined) {
        inputOutput.set("inputParameters", []);
      }
    }

    const integrarDoczConfigInputParameter = elementHelper.createElement(
      "camunda:InputParameter",
      { name: "doczConfig" },
      inputOutput,
      bpmnFactory,
    );

    const integrarDoczConfigScript = elementHelper.createElement(
      "camunda:Script",
      {
        scriptFormat: "JavaScript",
        value: convertToCamundaScriptValue(JSON.stringify(values)),
      },
      integrarDoczConfigInputParameter,
      bpmnFactory,
    );

    integrarDoczConfigInputParameter.set(
      "definition",
      integrarDoczConfigScript,
    );

    inputOutput.set("inputParameters", [integrarDoczConfigInputParameter]);
    if (AddExtension) {
      extensionElements.set("values", [inputOutput]);
      bo.set("extensionElements", extensionElements);
    }
    modeling.updateProperties(element, {});
  };

  const saveIntegrarDoczEtiquetaConfig = function (
    businessObject,
    element,
    extensionElements,
    bpmnFactory,
    values,
  ) {
    const bo = getBusinessObject(element);
    extensionElements = bo.get("extensionElements");
    let AddExtension = false;
    let inputOutput = null;

    if (!extensionElements) {
      AddExtension = true;
      extensionElements = elementHelper.createElement(
        "bpmn:ExtensionElements",
        {},
        businessObject,
        bpmnFactory,
      );
      inputOutput = elementHelper.createElement(
        "camunda:InputOutput",
        {},
        extensionElements,
        bpmnFactory,
      );
    } else {
      inputOutput = extensionElements.values.find(function (elem) {
        if (elem.$type === "camunda:InputOutput") {
          return true;
        }
        return false;
      });
      if (inputOutput.inputParameters === undefined) {
        inputOutput.set("inputParameters", []);
      }
    }

    const integrarDoczEtiquetaConfigInputParameter =
      elementHelper.createElement(
        "camunda:InputParameter",
        { name: "doczEtiquetaConfig" },
        inputOutput,
        bpmnFactory,
      );

    const integrarDoczEtiquetaConfigScript = elementHelper.createElement(
      "camunda:Script",
      {
        scriptFormat: "JavaScript",
        value: convertToCamundaScriptValue(JSON.stringify(values)),
      },
      integrarDoczEtiquetaConfigInputParameter,
      bpmnFactory,
    );

    integrarDoczEtiquetaConfigInputParameter.set(
      "definition",
      integrarDoczEtiquetaConfigScript,
    );

    inputOutput.set("inputParameters", [
      integrarDoczEtiquetaConfigInputParameter,
    ]);
    if (AddExtension) {
      extensionElements.set("values", [inputOutput]);
      bo.set("extensionElements", extensionElements);
    }
    modeling.updateProperties(element, {});
  };

  const saveIntegrarDoczSesiConfig = function (
    businessObject,
    element,
    extensionElements,
    bpmnFactory,
    values,
  ) {
    const bo = getBusinessObject(element);
    extensionElements = bo.get("extensionElements");
    let AddExtension = false;
    let inputOutput = null;

    if (!extensionElements) {
      AddExtension = true;
      extensionElements = elementHelper.createElement(
        "bpmn:ExtensionElements",
        {},
        businessObject,
        bpmnFactory,
      );
      inputOutput = elementHelper.createElement(
        "camunda:InputOutput",
        {},
        extensionElements,
        bpmnFactory,
      );
    } else {
      inputOutput = extensionElements.values.find(function (elem) {
        if (elem.$type === "camunda:InputOutput") {
          return true;
        }
        return false;
      });
      if (inputOutput.inputParameters === undefined) {
        inputOutput.set("inputParameters", []);
      }
    }

    const integrarDoczSesiConfigInputParameter = elementHelper.createElement(
      "camunda:InputParameter",
      { name: "doczSesiConfig" },
      inputOutput,
      bpmnFactory,
    );

    const integrarDoczSesiConfigScript = elementHelper.createElement(
      "camunda:Script",
      {
        scriptFormat: "JavaScript",
        value: convertToCamundaScriptValue(JSON.stringify(values)),
      },
      integrarDoczSesiConfigInputParameter,
      bpmnFactory,
    );

    integrarDoczSesiConfigInputParameter.set(
      "definition",
      integrarDoczSesiConfigScript,
    );

    inputOutput.set("inputParameters", [integrarDoczSesiConfigInputParameter]);
    if (AddExtension) {
      extensionElements.set("values", [inputOutput]);
      bo.set("extensionElements", extensionElements);
    }
    modeling.updateProperties(element, {});
  };

  const saveIntegrarSeiConfig = function (
    businessObject,
    element,
    extensionElements,
    bpmnFactory,
    values,
  ) {
    const bo = getBusinessObject(element);
    extensionElements = bo.get("extensionElements");
    let AddExtension = false;
    let inputOutput = null;

    if (!extensionElements) {
      AddExtension = true;
      extensionElements = elementHelper.createElement(
        "bpmn:ExtensionElements",
        {},
        businessObject,
        bpmnFactory,
      );
      inputOutput = elementHelper.createElement(
        "camunda:InputOutput",
        {},
        extensionElements,
        bpmnFactory,
      );
    } else {
      inputOutput = extensionElements.values.find(function (elem) {
        return elem.$type === "camunda:InputOutput";
      });
      if (!inputOutput) {
        inputOutput = elementHelper.createElement(
          "camunda:InputOutput",
          {},
          extensionElements,
          bpmnFactory,
        );
        extensionElements.set("values", [
          ...extensionElements.values,
          inputOutput,
        ]);
      }
      if (inputOutput.inputParameters === undefined) {
        inputOutput.set("inputParameters", []);
      }
    }

    const integrarSeiConfigInputParameter = elementHelper.createElement(
      "camunda:InputParameter",
      { name: "SeiConfig" },
      inputOutput,
      bpmnFactory,
    );

    const integrarSeiConfigScript = elementHelper.createElement(
      "camunda:Script",
      {
        scriptFormat: "JavaScript",
        value: convertToCamundaScriptValue(JSON.stringify(values)),
      },
      integrarSeiConfigInputParameter,
      bpmnFactory,
    );

    integrarSeiConfigInputParameter.set("definition", integrarSeiConfigScript);
    inputOutput.set("inputParameters", [integrarSeiConfigInputParameter]);

    if (AddExtension) {
      extensionElements.set("values", [inputOutput]);
      bo.set("extensionElements", extensionElements);
    }
    modeling.updateProperties(element, {});
  };

  const saveIntegrarAssinaturaConfig = function (
    businessObject,
    element,
    extensionElements,
    bpmnFactory,
    values,
  ) {
    const bo = getBusinessObject(element);
    extensionElements = bo.get("extensionElements");
    let AddExtension = false;
    let inputOutput = null;

    if (!extensionElements) {
      AddExtension = true;
      extensionElements = elementHelper.createElement(
        "bpmn:ExtensionElements",
        {},
        businessObject,
        bpmnFactory,
      );
      inputOutput = elementHelper.createElement(
        "camunda:InputOutput",
        {},
        extensionElements,
        bpmnFactory,
      );
    } else {
      inputOutput = extensionElements.values.find(function (elem) {
        if (elem.$type === "camunda:InputOutput") {
          return true;
        }
        return false;
      });
      if (inputOutput.inputParameters === undefined) {
        inputOutput.set("inputParameters", []);
      }
    }

    const integrarAssinaturaConfigInputParameter = elementHelper.createElement(
      "camunda:InputParameter",
      { name: "signerConfig" },
      inputOutput,
      bpmnFactory,
    );

    const integrarAssinaturaConfigScript = elementHelper.createElement(
      "camunda:Script",
      {
        scriptFormat: "JavaScript",
        value: convertToCamundaScriptValue(JSON.stringify(values)),
      },
      integrarAssinaturaConfigInputParameter,
      bpmnFactory,
    );

    integrarAssinaturaConfigInputParameter.set(
      "definition",
      integrarAssinaturaConfigScript,
    );

    inputOutput.set("inputParameters", [
      integrarAssinaturaConfigInputParameter,
    ]);
    if (AddExtension) {
      extensionElements.set("values", [inputOutput]);
      bo.set("extensionElements", extensionElements);
    }
    modeling.updateProperties(element, {});
  };

  const saveIntegrarAssinaturaLoteConfig = function (
    businessObject,
    element,
    extensionElements,
    bpmnFactory,
    values,
  ) {
    const bo = getBusinessObject(element);
    extensionElements = bo.get("extensionElements");
    let AddExtension = false;
    let inputOutput = null;

    if (!extensionElements) {
      AddExtension = true;
      extensionElements = elementHelper.createElement(
        "bpmn:ExtensionElements",
        {},
        businessObject,
        bpmnFactory,
      );
      inputOutput = elementHelper.createElement(
        "camunda:InputOutput",
        {},
        extensionElements,
        bpmnFactory,
      );
    } else {
      inputOutput = extensionElements.values.find(function (elem) {
        if (elem.$type === "camunda:InputOutput") {
          return true;
        }
        return false;
      });
      if (inputOutput.inputParameters === undefined) {
        inputOutput.set("inputParameters", []);
      }
    }

    const integrarAssinaturaLoteConfigInputParameter =
      elementHelper.createElement(
        "camunda:InputParameter",
        { name: "signerBatchConfig" },
        inputOutput,
        bpmnFactory,
      );

    const integrarAssinaturaLoteConfigScript = elementHelper.createElement(
      "camunda:Script",
      {
        scriptFormat: "JavaScript",
        value: convertToCamundaScriptValue(JSON.stringify(values)),
      },
      integrarAssinaturaLoteConfigInputParameter,
      bpmnFactory,
    );

    integrarAssinaturaLoteConfigInputParameter.set(
      "definition",
      integrarAssinaturaLoteConfigScript,
    );

    inputOutput.set("inputParameters", [
      integrarAssinaturaLoteConfigInputParameter,
    ]);
    if (AddExtension) {
      extensionElements.set("values", [inputOutput]);
      bo.set("extensionElements", extensionElements);
    }
    modeling.updateProperties(element, {});
  };

  const saveIntegrarAssinaturaLoteGetResultConfig = function (
    businessObject,
    element,
    extensionElements,
    bpmnFactory,
    values,
  ) {
    const bo = getBusinessObject(element);
    extensionElements = bo.get("extensionElements");
    let AddExtension = false;
    let inputOutput = null;

    if (!extensionElements) {
      AddExtension = true;
      extensionElements = elementHelper.createElement(
        "bpmn:ExtensionElements",
        {},
        businessObject,
        bpmnFactory,
      );
      inputOutput = elementHelper.createElement(
        "camunda:InputOutput",
        {},
        extensionElements,
        bpmnFactory,
      );
    } else {
      inputOutput = extensionElements.values.find(function (elem) {
        if (elem.$type === "camunda:InputOutput") {
          return true;
        }
        return false;
      });
      if (inputOutput.inputParameters === undefined) {
        inputOutput.set("inputParameters", []);
      }
    }

    const integrarAssinaturaLoteGetResultConfigInputParameter =
      elementHelper.createElement(
        "camunda:InputParameter",
        { name: "signerBatchGetResultConfig" },
        inputOutput,
        bpmnFactory,
      );

    const integrarAssinaturaLoteGetResultConfigScript =
      elementHelper.createElement(
        "camunda:Script",
        {
          scriptFormat: "JavaScript",
          value: convertToCamundaScriptValue(JSON.stringify(values)),
        },
        integrarAssinaturaLoteGetResultConfigInputParameter,
        bpmnFactory,
      );

    integrarAssinaturaLoteGetResultConfigInputParameter.set(
      "definition",
      integrarAssinaturaLoteGetResultConfigScript,
    );

    inputOutput.set("inputParameters", [
      integrarAssinaturaLoteGetResultConfigInputParameter,
    ]);
    if (AddExtension) {
      extensionElements.set("values", [inputOutput]);
      bo.set("extensionElements", extensionElements);
    }
    modeling.updateProperties(element, {});
  };

  const saveIntegrarApiManagerConfig = function (
    businessObject,
    element,
    extensionElements,
    bpmnFactory,
    values,
  ) {
    const bo = getBusinessObject(element);
    extensionElements = bo.get("extensionElements");
    let AddExtension = false;
    let inputOutput = null;

    if (!extensionElements) {
      AddExtension = true;
      extensionElements = elementHelper.createElement(
        "bpmn:ExtensionElements",
        {},
        businessObject,
        bpmnFactory,
      );
      inputOutput = elementHelper.createElement(
        "camunda:InputOutput",
        {},
        extensionElements,
        bpmnFactory,
      );
    } else {
      inputOutput = extensionElements.values.find(function (elem) {
        if (elem.$type === "camunda:InputOutput") {
          return true;
        }
        return false;
      });
      if (inputOutput.inputParameters === undefined) {
        inputOutput.set("inputParameters", []);
      }
    }

    const integrarApiManagerConfigInputParameter = elementHelper.createElement(
      "camunda:InputParameter",
      { name: "apiManagerConfig" },
      inputOutput,
      bpmnFactory,
    );

    const integrarApiManagerConfigScript = elementHelper.createElement(
      "camunda:Script",
      {
        scriptFormat: "JavaScript",
        value: convertToCamundaScriptValue(JSON.stringify(values)),
      },
      integrarApiManagerConfigInputParameter,
      bpmnFactory,
    );

    integrarApiManagerConfigInputParameter.set(
      "definition",
      integrarApiManagerConfigScript,
    );

    inputOutput.set("inputParameters", [
      integrarApiManagerConfigInputParameter,
    ]);
    if (AddExtension) {
      extensionElements.set("values", [inputOutput]);
      bo.set("extensionElements", extensionElements);
    }
    modeling.updateProperties(element, {});
  };

  const saveGerarQrBarCodeConfig = function (
    businessObject,
    element,
    extensionElements,
    bpmnFactory,
    values,
  ) {
    const bo = getBusinessObject(element);
    extensionElements = bo.get("extensionElements");
    let AddExtension = false;
    let inputOutput = null;

    if (!extensionElements) {
      AddExtension = true;
      extensionElements = elementHelper.createElement(
        "bpmn:ExtensionElements",
        {},
        businessObject,
        bpmnFactory,
      );
      inputOutput = elementHelper.createElement(
        "camunda:InputOutput",
        {},
        extensionElements,
        bpmnFactory,
      );
    } else {
      inputOutput = extensionElements.values.find(function (elem) {
        if (elem.$type === "camunda:InputOutput") {
          return true;
        }
        return false;
      });
      if (inputOutput.inputParameters === undefined) {
        inputOutput.set("inputParameters", []);
      }
    }

    const qrBarCodeConfigInputParameter = elementHelper.createElement(
      "camunda:InputParameter",
      { name: "qrBarCodeConfig" },
      inputOutput,
      bpmnFactory,
    );

    const gerarQrBarCodeConfigScript = elementHelper.createElement(
      "camunda:Script",
      {
        scriptFormat: "JavaScript",
        value: convertToCamundaScriptValue(JSON.stringify(values)),
      },
      qrBarCodeConfigInputParameter,
      bpmnFactory,
    );

    qrBarCodeConfigInputParameter.set("definition", gerarQrBarCodeConfigScript);

    inputOutput.set("inputParameters", [qrBarCodeConfigInputParameter]);
    if (AddExtension) {
      extensionElements.set("values", [inputOutput]);
      bo.set("extensionElements", extensionElements);
    }
    modeling.updateProperties(element, {});
  };

  function getAttribute(element, prop) {
    const type = getCallableType(element);
    return (attributeInfo[type] || {})[prop];
  }

  function getCallActivityBindingValue(element) {
    const type = getCallableType(element);
    const bo = getBusinessObject(element);
    const attr = (attributeInfo[type] || {}).binding;
    return bo.get(attr);
  }

  function getDelegateVariableMappingType(element) {
    const bo = getBusinessObject(element);

    const boVariableMappingClass = bo.get("camunda:variableMappingClass"),
      boVariableMappingDelegateExpression = bo.get(
        "camunda:variableMappingDelegateExpression",
      );

    let delegateVariableMappingType = "";
    if (typeof boVariableMappingClass !== "undefined") {
      delegateVariableMappingType = "variableMappingClass";
    } else if (typeof boVariableMappingDelegateExpression !== "undefined") {
      delegateVariableMappingType = "variableMappingDelegateExpression";
    }

    return delegateVariableMappingType;
  }

  function returnsbpmndefinitions(element) {
    if (element.$type === "bpmn:Definitions") return element;
    return returnsbpmndefinitions(element.$parent);
  }

  const supertype = getCallableType(element);
  if (
    supertype !== "smartrules" &&
    supertype !== "registrardocumento" &&
    supertype !== "gerarminuta" &&
    supertype !== "gerarpdfregistrar" &&
    supertype !== "registrararquivardocumento" &&
    supertype !== "gerarpdfnew" &&
    supertype !== "gerarxml" &&
    supertype !== "integrardocz" &&
    supertype !== "integrardoczetiqueta" &&
    supertype !== "integrardoczsesi" &&
    supertype !== "integrarsei" &&
    supertype !== "integrarassinatura" &&
    supertype !== "integrarassinaturalote" &&
    supertype !== "integrarassinaturalotegetresult" &&
    supertype !== "integrarapimanager" &&
    supertype !== "gerarqrbarcode"
  ) {
    entries.push(
      entryFactory.textField(translate, {
        id: "callable-element-ref",
        dataValueLabel: "callableElementLabel",
        modelProperty: "callableElementRef",

        get(element, node) {
          let callableElementRef;

          const attr = getAttribute(element, "element");
          if (attr) {
            const bo = getBusinessObject(element);
            callableElementRef = bo.get(attr);
          }

          let label = "";
          const type = getCallableType(element);
          if (type === "bpmn") {
            label = translate("Called Element");
          } else if (type === "cmmn") {
            label = translate("Case Ref");
          } else if (type === "dmn") {
            label = translate("Decision Ref");
          }

          return {
            callableElementRef,
            callableElementLabel: label,
          };
        },

        set(element, values, node) {
          const newCallableElementRef = values.callableElementRef;
          const attr = getAttribute(element, "element");

          const props = {};
          props[attr] = newCallableElementRef || "";

          return cmdHelper.updateProperties(element, props);
        },
        validate(element, values, node) {
          const elementRef = values.callableElementRef;
          const type = getCallableType(element);
          return isSupportedCallableType(type) && !elementRef
            ? { callableElementRef: translate("Must provide a value") }
            : {};
        },

        hidden(element, node) {
          return !isSupportedCallableType(getCallableType(element));
        },
      }),
    );

    entries.push(
      entryFactory.selectBox(translate, {
        id: "callable-binding",
        label: translate("Binding"),
        selectOptions(element) {
          const type = getCallableType(element);
          let options;

          if (type === "cmmn") {
            options = bindingOptions.filter(function (bindingOption) {
              return bindingOption.value !== "versionTag";
            });
          } else {
            options = bindingOptions;
          }
          return options;
        },
        modelProperty: "callableBinding",

        get(element, node) {
          let callableBinding;

          const attr = getAttribute(element, "binding");
          if (attr) {
            const bo = getBusinessObject(element);
            callableBinding = bo.get(attr) || "latest";
          }

          return {
            callableBinding,
          };
        },

        set(element, values, node) {
          const binding = values.callableBinding;
          const attr = getAttribute(element, "binding"),
            attrVer = getAttribute(element, "version"),
            attrVerTag = getAttribute(element, "versionTag");

          const props = {};
          props[attr] = binding;

          // set version and versionTag values always to undefined to delete the existing value
          props[attrVer] = undefined;
          props[attrVerTag] = undefined;

          return cmdHelper.updateProperties(element, props);
        },

        hidden(element, node) {
          return !isSupportedCallableType(getCallableType(element));
        },
      }),
    );

    entries.push(
      entryFactory.textField(translate, {
        id: "callable-version",
        label: translate("Version"),
        modelProperty: "callableVersion",

        get(element, node) {
          let callableVersion;

          const attr = getAttribute(element, "version");
          if (attr) {
            const bo = getBusinessObject(element);
            callableVersion = bo.get(attr);
          }

          return {
            callableVersion,
          };
        },

        set(element, values, node) {
          const version = values.callableVersion;
          const attr = getAttribute(element, "version");

          const props = {};
          props[attr] = version || undefined;

          return cmdHelper.updateProperties(element, props);
        },

        validate(element, values, node) {
          const version = values.callableVersion;

          const type = getCallableType(element);
          return (
            isSupportedCallableType(type) &&
            getCallActivityBindingValue(element) === "version" &&
            (!version
              ? { callableVersion: translate("Must provide a value") }
              : {})
          );
        },

        hidden(element, node) {
          const type = getCallableType(element);
          return (
            !isSupportedCallableType(type) ||
            getCallActivityBindingValue(element) !== "version"
          );
        },
      }),
    );

    entries.push(
      entryFactory.textField(translate, {
        id: "callable-version-tag",
        label: translate("Version Tag"),
        modelProperty: "versionTag",

        get(element, node) {
          let versionTag;

          const attr = getAttribute(element, "versionTag");

          if (attr) {
            const bo = getBusinessObject(element);

            versionTag = bo.get(attr);
          }

          return {
            versionTag,
          };
        },

        set(element, values, node) {
          const versionTag = values.versionTag;

          const attr = getAttribute(element, "versionTag");

          const props = {};

          props[attr] = versionTag || undefined;

          return cmdHelper.updateProperties(element, props);
        },

        validate(element, values, node) {
          const versionTag = values.versionTag;

          const type = getCallableType(element);

          return (
            isSupportedCallableType(type) &&
            getCallActivityBindingValue(element) === "versionTag" &&
            (!versionTag
              ? { versionTag: translate("Must provide a value") }
              : {})
          );
        },

        hidden(element, node) {
          const type = getCallableType(element);

          return (
            !isSupportedCallableType(type) ||
            getCallActivityBindingValue(element) !== "versionTag"
          );
        },
      }),
    );

    entries.push(
      entryFactory.textField(translate, {
        id: "tenant-id",
        label: translate("Tenant Id"),
        modelProperty: "tenantId",

        get(element, node) {
          let tenantId;

          const attr = getAttribute(element, "tenantId");
          if (attr) {
            const bo = getBusinessObject(element);
            tenantId = bo.get(attr);
          }

          return {
            tenantId,
          };
        },

        set(element, values, node) {
          const tenantId = values.tenantId;
          const attr = getAttribute(element, "tenantId");

          const props = {};
          props[attr] = tenantId || undefined;

          return cmdHelper.updateProperties(element, props);
        },

        hidden(element, node) {
          const type = getCallableType(element);
          return !isSupportedCallableType(type);
        },
      }),
    );
  }

  if (supertype === "smartrules") {
    const BRMSButton = {
      id: "BrmsButton",
      modelProperty: "BrmsButton",
      html:
        '<button class="brmsButton" ' +
        'id="cam-brms-config" ' +
        'data-action="configBrms">' +
        "<span>" +
        translate("Config SmartRules") +
        "</span>" +
        "</button>",

      // eslint-disable-next-line no-empty-function
      get(element, node) {},
      // eslint-disable-next-line no-empty-function
      set(element, values) {},
      configBrms(element, values) {
        const bo = getBusinessObject(element);
        const businessObject = getBusinessObject(element); // eslint-disable-line no-use-before-define
        // eslint-disable-next-line no-unused-vars
        let jsonObject = null;

        const bpmnDefinitions = returnsbpmndefinitions(bo);
        const rootElements = bpmnDefinitions.rootElements.find(function (elem) {
          if (elem.$type === "bpmn:Process") {
            return true;
          }
          return false;
        });
        // eslint-disable-next-line no-unused-vars
        const fields = getTaskFields(rootElements.flowElements, bo.id);
        const extensionElements = bo.get("extensionElements");

        if (extensionElements) {
          const data = extensionElements.values.find(function (elem) {
            if (elem.$type === "camunda:InputOutput") {
              return true;
            }
            return false;
          });

          jsonObject =
            data.inputParameters && data.inputParameters[0].value
              ? parseSmartRule(JSON.parse(data.inputParameters[0].value), "IN")
              : null;
        }
        // eslint-disable-next-line no-unused-vars
        const modalBRMS = document.createElement("modalBRMS");
        //BuildBrmsBuildModal(fields, modalBRMS, saveConfig, element, bpmnFactory, extensionElements, businessObject, jsonObject);
      },
    };

    entries.push(BRMSButton);
  }

  if (supertype === "registrardocumento") {
    const RegistrarDocumentoButton = {
      id: "RegistrarDocumentoButton",
      modelProperty: "RegistrarDocumentoButton",
      html:
        '<button class="RegistrarDocumentoButton" ' +
        'id="cam-registrarDocumento-config" ' +
        'data-action="configRegistrarDocumento" style="width: 100%;">' +
        "<span>" +
        translate("Config") +
        "</span>" +
        "</button>",

      // eslint-disable-next-line no-empty-function
      get(element, node) {},
      // eslint-disable-next-line no-empty-function
      set(element, values) {},
      configRegistrarDocumento(element, values) {
        const bo = getBusinessObject(element);
        const businessObject = getBusinessObject(element); // eslint-disable-line no-use-before-define
        let inputValues = null;

        const bpmnDefinitions = returnsbpmndefinitions(bo);
        const rootElements = bpmnDefinitions.rootElements.find(function (elem) {
          if (elem.$type === "bpmn:Process") {
            return true;
          }
          return false;
        });
        const fields = getTaskFields(rootElements.flowElements, bo.id);
        const extensionElements = bo.get("extensionElements");

        if (extensionElements) {
          const data = extensionElements.values.find(function (elem) {
            if (elem.$type === "camunda:InputOutput") {
              return true;
            }
            return false;
          });

          //armazena as variaves de entrada em um variavel para facilitar na utilização no modal
          inputValues = readRegistrarDocumentoFromModeler(
            data && data.inputParameters,
          );
        } else {
          inputValues = readRegistrarDocumentoFromModeler(null);
        }

        const modalRegistrarDocumento = document.createElement(
          "modalRegistrarDocumento",
        );
        BuildRegistrarDocumentoBuildModal(
          fields,
          modalRegistrarDocumento,
          saveRegistrarDocumentoConfig,
          element,
          bpmnFactory,
          extensionElements,
          businessObject,
          inputValues,
        );
      },
    };

    entries.push(RegistrarDocumentoButton);
  }

  if (supertype === "gerarminuta") {
    const GerarMinutaButton = {
      id: "GerarMinutaButton",
      modelProperty: "GerarMinutaButton",
      html:
        '<button class="GerarMinutaButton" ' +
        'id="cam-gerarMinuta-config" ' +
        'data-action="configGerarMinuta" style="width: 100%;">' +
        "<span>" +
        translate("Config") +
        "</span>" +
        "</button>",
      // eslint-disable-next-line no-empty-function
      get(element, node) {},
      // eslint-disable-next-line no-empty-function
      set(element, values) {},
      configGerarMinuta(element, values) {
        const bo = getBusinessObject(element);
        const businessObject = getBusinessObject(element); // eslint-disable-line no-use-before-define
        let inputValues = null;

        const bpmnDefinitions = returnsbpmndefinitions(bo);
        const rootElements = bpmnDefinitions.rootElements.find(function (elem) {
          if (elem.$type === "bpmn:Process") {
            return true;
          }
          return false;
        });
        const fields = getTaskFields(rootElements.flowElements, bo.id);
        const extensionElements = bo.get("extensionElements");

        if (extensionElements) {
          const data = extensionElements.values.find(function (elem) {
            if (elem.$type === "camunda:InputOutput") {
              return true;
            }
            return false;
          });

          //armazena as variaves de entrada em um variavel para facilitar na utilização no modal
          inputValues = readGerarMinutaFromModeler(
            data && data.inputParameters,
          );
        } else {
          inputValues = readGerarMinutaFromModeler(null);
        }

        const modalGerarMinuta = document.createElement("modalGerarMinuta");
        BuildGerarMinutaBuildModal(
          fields,
          modalGerarMinuta,
          saveGerarMinutaConfig,
          element,
          bpmnFactory,
          extensionElements,
          businessObject,
          inputValues,
        );
      },
    };

    entries.push(GerarMinutaButton);
  }

  if (supertype === "gerarpdfregistrar") {
    const GerarPdfRegistrarButton = {
      id: "GerarPdfRegistrarButton",
      modelProperty: "GerarPdfRegistrarButton",
      html:
        '<button class="GerarPdfRegistrarButton" ' +
        'id="cam-gerarPdfRegistrar-config" ' +
        'data-action="configGerarPdfRegistrar" style="width: 100%;">' +
        "<span>" +
        translate("Config") +
        "</span>" +
        "</button>",

      // eslint-disable-next-line no-empty-function
      get(element, node) {},
      // eslint-disable-next-line no-empty-function
      set(element, values) {},
      configGerarPdfRegistrar(element, values) {
        const bo = getBusinessObject(element);
        const businessObject = getBusinessObject(element); // eslint-disable-line no-use-before-define
        let inputValues = null;

        const bpmnDefinitions = returnsbpmndefinitions(bo);
        const rootElements = bpmnDefinitions.rootElements.find(function (elem) {
          if (elem.$type === "bpmn:Process") {
            return true;
          }
          return false;
        });
        const fields = getTaskFields(rootElements.flowElements, bo.id);
        const extensionElements = bo.get("extensionElements");

        if (extensionElements) {
          const data = extensionElements.values.find(function (elem) {
            if (elem.$type === "camunda:InputOutput") {
              return true;
            }
            return false;
          });

          //armazena as variaves de entrada em um variavel para facilitar na utilização no modal
          inputValues = readGerarPdfRegistrarFromModeler(
            data && data.inputParameters,
          );
        } else {
          inputValues = readGerarPdfRegistrarFromModeler(null);
        }

        const modalGerarPdfRegistrar = document.createElement(
          "modalGerarPdfRegistrar",
        );
        BuildGerarPdfRegistrarBuildModal(
          fields,
          modalGerarPdfRegistrar,
          saveGerarPdfRegistrarConfig,
          element,
          bpmnFactory,
          extensionElements,
          businessObject,
          inputValues,
        );
      },
    };

    entries.push(GerarPdfRegistrarButton);
  }

  if (supertype === "registrararquivardocumento") {
    const RegistrarArquivarDocumentoButton = {
      id: "RegistrarArquivarDocumentoButton",
      modelProperty: "RegistrarArquivarDocumentoButton",
      html:
        '<button class="RegistrarArquivarDocumentoButton" ' +
        'id="cam-registrarArquivarDocumento-config" ' +
        'data-action="configRegistrarArquivarDocumento" style="width: 100%;">' +
        "<span>" +
        translate("Config") +
        "</span>" +
        "</button>",

      // eslint-disable-next-line no-empty-function
      get(element, node) {},
      // eslint-disable-next-line no-empty-function
      set(element, values) {},
      configRegistrarArquivarDocumento(element, values) {
        const bo = getBusinessObject(element);
        const businessObject = getBusinessObject(element); // eslint-disable-line no-use-before-define
        let jsonObject = null;

        const bpmnDefinitions = returnsbpmndefinitions(bo);

        const fields = getUniqueTaskFields(bo);
        const extensionElements = bo.get("extensionElements");

        if (extensionElements) {
          const data = extensionElements.values.find(function (elem) {
            if (elem.$type === "camunda:InputOutput") {
              return true;
            }
            return false;
          });

          jsonObject =
            data && data.inputParameters
              ? getScriptParameterByName(
                  data.inputParameters,
                  "registrarDocumentoWithPathConfig",
                )
              : null;
        }

        const modalRegistrarArquivarDocumentoConfig = document.createElement(
          "modalRegistrarArquivarDocumentoConfig",
        );
        BuildRegistrarArquivarDocumentoModal(
          fields,
          modalRegistrarArquivarDocumentoConfig,
          saveRegistrarArquivarDocumentoConfig,
          element,
          bpmnFactory,
          extensionElements,
          businessObject,
          jsonObject,
        );
      },
    };

    entries.push(RegistrarArquivarDocumentoButton);
  }

  if (supertype === "gerarpdfnew") {
    const GerarPdfNewButton = {
      id: "GerarPdfNewButton",
      modelProperty: "GerarPdfNewButton",
      html:
        '<button class="GerarPdfNewButton" ' +
        'id="cam-GerarPdfNew-config" ' +
        'data-action="configGerarPdfNew" style="width: 100%;">' +
        "<span>" +
        translate("Config") +
        "</span>" +
        "</button>",

      // eslint-disable-next-line no-empty-function
      get(element, node) {},
      // eslint-disable-next-line no-empty-function
      set(element, values) {},
      configGerarPdfNew(element, values) {
        const bo = getBusinessObject(element);
        const businessObject = getBusinessObject(element); // eslint-disable-line no-use-before-define
        let jsonObject = null;

        const bpmnDefinitions = returnsbpmndefinitions(bo);

        const fields = getUniqueTaskFields(bo);
        const extensionElements = bo.get("extensionElements");

        if (extensionElements) {
          const data = extensionElements.values.find(function (elem) {
            if (elem.$type === "camunda:InputOutput") {
              return true;
            }
            return false;
          });

          jsonObject =
            data && data.inputParameters
              ? getScriptParameterByName(
                  data.inputParameters,
                  "generatePdfFromTemplateWithPathConfig",
                )
              : null;
        }

        const modalGerarPdfNewConfig = document.createElement(
          "modalGerarPdfNewConfig",
        );
        BuildGerarPdfNewModal(
          fields,
          modalGerarPdfNewConfig,
          saveGerarPdfNewConfig,
          element,
          bpmnFactory,
          extensionElements,
          businessObject,
          jsonObject,
        );
      },
    };

    entries.push(GerarPdfNewButton);
  }

  if (supertype === "gerarxml") {
    const GerarXmlButton = {
      id: "GerarXmlButton",
      modelProperty: "GerarXmlButton",
      html:
        '<button class="GerarXmlButton" ' +
        'id="cam-GerarXml-config" ' +
        'data-action="configGerarXml" style="width: 100%;">' +
        "<span>" +
        translate("Config") +
        "</span>" +
        "</button>",

      // eslint-disable-next-line no-empty-function
      get(element, node) {},
      // eslint-disable-next-line no-empty-function
      set(element, values) {},
      configGerarXml(element, values) {
        const bo = getBusinessObject(element);
        const businessObject = getBusinessObject(element); // eslint-disable-line no-use-before-define
        let jsonObject = null;

        const bpmnDefinitions = returnsbpmndefinitions(bo);

        const fields = getUniqueTaskFields(bo);
        const extensionElements = bo.get("extensionElements");

        if (extensionElements) {
          const data = extensionElements.values.find(function (elem) {
            if (elem.$type === "camunda:InputOutput") {
              return true;
            }
            return false;
          });

          jsonObject =
            data && data.inputParameters
              ? getScriptParameterByName(
                  data.inputParameters,
                  "generateXmlFromTemplateConfig",
                )
              : null;
        }

        const modalGerarXmlConfig = document.createElement(
          "modalGerarXmlConfig",
        );
        BuildGerarXmlModal(
          fields,
          modalGerarXmlConfig,
          saveGerarXmlConfig,
          element,
          bpmnFactory,
          extensionElements,
          businessObject,
          jsonObject,
        );
      },
    };

    entries.push(GerarXmlButton);
  }

  if (supertype === "integrardocz") {
    const IntegrarDoczButton = {
      id: "IntegrarDoczButton",
      modelProperty: "IntegrarDoczButton",
      html:
        '<button class="IntegrarDoczButton" ' +
        'id="cam-integrarDocz-config" ' +
        'data-action="configIntegrarDocz" style="width: 100%;">' +
        "<span>" +
        translate("Config") +
        "</span>" +
        "</button>",

      // eslint-disable-next-line no-empty-function
      get(element, node) {},
      // eslint-disable-next-line no-empty-function
      set(element, values) {},
      configIntegrarDocz(element, values) {
        const bo = getBusinessObject(element);
        const businessObject = getBusinessObject(element); // eslint-disable-line no-use-before-define
        let jsonObject = null;

        const bpmnDefinitions = returnsbpmndefinitions(bo);

        const fields = getUniqueTaskFields(bo);
        const extensionElements = bo.get("extensionElements");

        if (extensionElements) {
          const data = extensionElements.values.find(function (elem) {
            if (elem.$type === "camunda:InputOutput") {
              return true;
            }
            return false;
          });

          jsonObject =
            data && data.inputParameters
              ? getScriptParameterByName(data.inputParameters, "doczConfig")
              : null;
        }

        const modalIntegrarDoczConfig = document.createElement(
          "modalIntegrarDoczConfig",
        );
        BuildIntegrarDoczModal(
          fields,
          modalIntegrarDoczConfig,
          saveIntegrarDoczConfig,
          element,
          bpmnFactory,
          extensionElements,
          businessObject,
          jsonObject,
        );
      },
    };

    entries.push(IntegrarDoczButton);
  }

  if (supertype === "integrardoczetiqueta") {
    const IntegrarDoczEtiquetaButton = {
      id: "IntegrarDoczEtiquetaButton",
      modelProperty: "IntegrarDoczEtiquetaButton",
      html:
        '<button class="IntegrarDoczEtiquetaButton" ' +
        'id="cam-integrarDoczEtiqueta-config" ' +
        'data-action="configIntegrarDoczEtiqueta" style="width: 100%;">' +
        "<span>" +
        translate("Config") +
        "</span>" +
        "</button>",

      // eslint-disable-next-line no-empty-function
      get(element, node) {},
      // eslint-disable-next-line no-empty-function
      set(element, values) {},
      configIntegrarDoczEtiqueta(element, values) {
        const bo = getBusinessObject(element);
        const businessObject = getBusinessObject(element); // eslint-disable-line no-use-before-define
        let jsonObject = null;

        const bpmnDefinitions = returnsbpmndefinitions(bo);

        const fields = getUniqueTaskFields(bo);
        const extensionElements = bo.get("extensionElements");

        if (extensionElements) {
          const data = extensionElements.values.find(function (elem) {
            if (elem.$type === "camunda:InputOutput") {
              return true;
            }
            return false;
          });

          jsonObject =
            data && data.inputParameters
              ? getScriptParameterByName(
                  data.inputParameters,
                  "doczEtiquetaConfig",
                )
              : null;
        }

        const modalIntegrarDoczEtiquetaConfig = document.createElement(
          "modalIntegrarDoczEtiquetaConfig",
        );
        BuildIntegrarDoczEtiquetaModal(
          fields,
          modalIntegrarDoczEtiquetaConfig,
          saveIntegrarDoczEtiquetaConfig,
          element,
          bpmnFactory,
          extensionElements,
          businessObject,
          jsonObject,
        );
      },
    };

    entries.push(IntegrarDoczEtiquetaButton);
  }

  if (supertype === "integrardoczsesi") {
    const IntegrarDoczSesiButton = {
      id: "IntegrarDoczSesiButton",
      modelProperty: "IntegrarDoczSesiButton",
      html:
        '<button class="IntegrarDoczSesiButton" ' +
        'id="cam-integrarDoczSesi-config" ' +
        'data-action="configIntegrarDoczSesi" style="width: 100%;">' +
        "<span>" +
        translate("Config") +
        "</span>" +
        "</button>",

      // eslint-disable-next-line no-empty-function
      get(element, node) {},
      // eslint-disable-next-line no-empty-function
      set(element, values) {},
      configIntegrarDoczSesi(element, values) {
        const bo = getBusinessObject(element);
        const businessObject = getBusinessObject(element); // eslint-disable-line no-use-before-define
        let jsonObject = null;

        const bpmnDefinitions = returnsbpmndefinitions(bo);

        const fields = getUniqueTaskFields(bo);
        const extensionElements = bo.get("extensionElements");

        if (extensionElements) {
          const data = extensionElements.values.find(function (elem) {
            if (elem.$type === "camunda:InputOutput") {
              return true;
            }
            return false;
          });

          jsonObject =
            data && data.inputParameters
              ? getScriptParameterByName(data.inputParameters, "doczSesiConfig")
              : null;
        }

        const modalIntegrarDoczSesiConfig = document.createElement(
          "modalIntegrarDoczSesiConfig",
        );
        BuildIntegrarDoczSesiModal(
          fields,
          modalIntegrarDoczSesiConfig,
          saveIntegrarDoczSesiConfig,
          element,
          bpmnFactory,
          extensionElements,
          businessObject,
          jsonObject,
        );
      },
    };

    entries.push(IntegrarDoczSesiButton);
  }

  if (supertype === "integrarsei") {
    const IntegrarSeiButton = {
      id: "IntegrarSeiButton",
      modelProperty: "IntegrarSeiButton",
      html:
        '<button class="IntegrarSeiButton" ' +
        'id="cam-integrarSei-config" ' +
        'data-action="configIntegrarSei" style="width: 100%;">' +
        "<span>" +
        translate("Config") +
        "</span>" +
        "</button>",

      get(element, node) {},
      set(element, values) {},
      configIntegrarSei(element, values) {
        const bo = getBusinessObject(element);
        const businessObject = getBusinessObject(element);
        let jsonObject = null;

        const fields = getUniqueTaskFields(bo);
        const extensionElements = bo.get("extensionElements");

        if (extensionElements) {
          const data = extensionElements.values.find(function (elem) {
            return elem.$type === "camunda:InputOutput";
          });

          jsonObject =
            data && data.inputParameters
              ? getScriptParameterByName(data.inputParameters, "SeiConfig") ||
                getScriptParameterByName(data.inputParameters, "seiConfig")
              : null;
        }

        const modalIntegrarSeiConfig = document.createElement(
          "modalIntegrarSeiConfig",
        );
        BuildIntegrarSeiModal(
          fields,
          modalIntegrarSeiConfig,
          saveIntegrarSeiConfig,
          element,
          bpmnFactory,
          extensionElements,
          businessObject,
          jsonObject,
        );
      },
    };

    entries.push(IntegrarSeiButton);
  }

  if (supertype === "integrarassinatura") {
    const IntegrarAssinaturaButton = {
      id: "IntegrarAssinaturaButton",
      modelProperty: "IntegrarAssinaturaButton",
      html:
        '<button class="IntegrarAssinaturaButton" ' +
        'id="cam-integrarAssinatura-config" ' +
        'data-action="configIntegrarAssinatura" style="width: 100%;">' +
        "<span>" +
        translate("Config") +
        "</span>" +
        "</button>",

      // eslint-disable-next-line no-empty-function
      get(element, node) {},
      // eslint-disable-next-line no-empty-function
      set(element, values) {},
      configIntegrarAssinatura(element, values) {
        const bo = getBusinessObject(element);
        const businessObject = getBusinessObject(element); // eslint-disable-line no-use-before-define
        let jsonObject = null;

        const bpmnDefinitions = returnsbpmndefinitions(bo);

        const fields = getUniqueTaskFields(bo);
        const extensionElements = bo.get("extensionElements");

        if (extensionElements) {
          const data = extensionElements.values.find(function (elem) {
            if (elem.$type === "camunda:InputOutput") {
              return true;
            }
            return false;
          });

          jsonObject =
            data && data.inputParameters
              ? getScriptParameterByName(data.inputParameters, "signerConfig")
              : null;
        }

        const modalIntegrarAssinaturaConfig = document.createElement(
          "modalIntegrarAssinaturaConfig",
        );
        BuildIntegrarAssinaturaModal(
          fields,
          modalIntegrarAssinaturaConfig,
          saveIntegrarAssinaturaConfig,
          element,
          bpmnFactory,
          extensionElements,
          businessObject,
          jsonObject,
        );
      },
    };

    entries.push(IntegrarAssinaturaButton);
  }

  if (supertype === "integrarassinaturalote") {
    const IntegrarAssinaturaLoteButton = {
      id: "IntegrarAssinaturaLoteButton",
      modelProperty: "IntegrarAssinaturaLoteButton",
      html:
        '<button class="IntegrarAssinaturaLoteButton" ' +
        'id="cam-integrarAssinaturaLote-config" ' +
        'data-action="configIntegrarAssinaturaLote" style="width: 100%;">' +
        "<span>" +
        translate("Config") +
        "</span>" +
        "</button>",

      // eslint-disable-next-line no-empty-function
      get(element, node) {},
      // eslint-disable-next-line no-empty-function
      set(element, values) {},
      configIntegrarAssinaturaLote(element, values) {
        const bo = getBusinessObject(element);
        const businessObject = getBusinessObject(element); // eslint-disable-line no-use-before-define
        let jsonObject = null;

        const bpmnDefinitions = returnsbpmndefinitions(bo);

        const fields = getUniqueTaskFields(bo);
        const extensionElements = bo.get("extensionElements");

        if (extensionElements) {
          const data = extensionElements.values.find(function (elem) {
            if (elem.$type === "camunda:InputOutput") {
              return true;
            }
            return false;
          });

          jsonObject =
            data && data.inputParameters
              ? getScriptParameterByName(
                  data.inputParameters,
                  "signerBatchConfig",
                )
              : null;
        }

        const modalIntegrarAssinaturaLoteConfig = document.createElement(
          "modalIntegrarAssinaturaLoteConfig",
        );
        BuildIntegrarAssinaturaLoteModal(
          fields,
          modalIntegrarAssinaturaLoteConfig,
          saveIntegrarAssinaturaLoteConfig,
          element,
          bpmnFactory,
          extensionElements,
          businessObject,
          jsonObject,
        );
      },
    };

    entries.push(IntegrarAssinaturaLoteButton);
  }

  if (supertype === "integrarassinaturalotegetresult") {
    const IntegrarAssinaturaLoteGetResultButton = {
      id: "IntegrarAssinaturaLoteGetResultButton",
      modelProperty: "IntegrarAssinaturaLoteGetResultButton",
      html:
        '<button class="IntegrarAssinaturaLoteGetResultButton" ' +
        'id="cam-integrarAssinaturaLoteGetResult-config" ' +
        'data-action="configIntegrarAssinaturaLoteGetResult" style="width: 100%;">' +
        "<span>" +
        translate("Config") +
        "</span>" +
        "</button>",

      // eslint-disable-next-line no-empty-function
      get(element, node) {},
      // eslint-disable-next-line no-empty-function
      set(element, values) {},
      configIntegrarAssinaturaLoteGetResult(element, values) {
        const bo = getBusinessObject(element);
        const businessObject = getBusinessObject(element); // eslint-disable-line no-use-before-define
        let jsonObject = null;

        const bpmnDefinitions = returnsbpmndefinitions(bo);

        const fields = getUniqueTaskFields(bo);
        const extensionElements = bo.get("extensionElements");

        if (extensionElements) {
          const data = extensionElements.values.find(function (elem) {
            if (elem.$type === "camunda:InputOutput") {
              return true;
            }
            return false;
          });

          jsonObject =
            data && data.inputParameters
              ? getScriptParameterByName(
                  data.inputParameters,
                  "signerBatchGetResultConfig",
                )
              : null;
        }

        const modalIntegrarAssinaturaLoteGetResultConfig =
          document.createElement("modalIntegrarAssinaturaLoteGetResultConfig");
        BuildIntegrarAssinaturaLoteGetResultModal(
          fields,
          modalIntegrarAssinaturaLoteGetResultConfig,
          saveIntegrarAssinaturaLoteGetResultConfig,
          element,
          bpmnFactory,
          extensionElements,
          businessObject,
          jsonObject,
        );
      },
    };

    entries.push(IntegrarAssinaturaLoteGetResultButton);
  }

  if (supertype === "integrarapimanager") {
    const IntegrarApiManagerButton = {
      id: "IntegrarApiManagerButton",
      modelProperty: "IntegrarApiManagerButton",
      html:
        '<button class="IntegrarApiManagerButton" ' +
        'id="cam-integrarApiManager-config" ' +
        'data-action="configIntegrarApiManager" style="width: 100%;">' +
        "<span>" +
        translate("Config") +
        "</span>" +
        "</button>",

      // eslint-disable-next-line no-empty-function
      get(element, node) {},
      // eslint-disable-next-line no-empty-function
      set(element, values) {},
      configIntegrarApiManager(element, values) {
        const bo = getBusinessObject(element);
        const businessObject = getBusinessObject(element); // eslint-disable-line no-use-before-define
        let jsonObject = null;

        const bpmnDefinitions = returnsbpmndefinitions(bo);

        const fields = getUniqueTaskFields(bo);
        const extensionElements = bo.get("extensionElements");

        if (extensionElements) {
          const data = extensionElements.values.find(function (elem) {
            if (elem.$type === "camunda:InputOutput") {
              return true;
            }
            return false;
          });

          jsonObject =
            data && data.inputParameters
              ? getScriptParameterByName(
                  data.inputParameters,
                  "apiManagerConfig",
                )
              : null;
        }

        const modalIntegrarApiManagerConfig = document.createElement(
          "modalIntegrarApiManagerConfig",
        );
        BuildIntegrarApiManagerModal(
          fields,
          modalIntegrarApiManagerConfig,
          saveIntegrarApiManagerConfig,
          element,
          bpmnFactory,
          extensionElements,
          businessObject,
          jsonObject,
        );
      },
    };

    entries.push(IntegrarApiManagerButton);
  }

  if (supertype === "gerarqrbarcode") {
    const GerarQrBarCodeButton = {
      id: "GerarQrBarCodeButton",
      modelProperty: "GerarQrBarCodeButton",
      html:
        '<button class="GerarQrBarCodeButton" ' +
        'id="cam-gerarQrBarCode-config" ' +
        'data-action="configGerarQrBarCode" style="width: 100%;">' +
        "<span>" +
        translate("Config") +
        "</span>" +
        "</button>",

      // eslint-disable-next-line no-empty-function
      get(element, node) {},
      // eslint-disable-next-line no-empty-function
      set(element, values) {},
      configGerarQrBarCode(element, values) {
        const bo = getBusinessObject(element);
        const businessObject = getBusinessObject(element); // eslint-disable-line no-use-before-define
        let jsonObject = null;

        const bpmnDefinitions = returnsbpmndefinitions(bo);

        const fields = getUniqueTaskFields(bo);
        const extensionElements = bo.get("extensionElements");

        if (extensionElements) {
          const data = extensionElements.values.find(function (elem) {
            if (elem.$type === "camunda:InputOutput") {
              return true;
            }
            return false;
          });

          jsonObject =
            data && data.inputParameters
              ? getScriptParameterByName(
                  data.inputParameters,
                  "qrBarCodeConfig",
                )
              : null;
        }

        const modalGerarQrBarCodeConfig = document.createElement(
          "modalGerarQrBarCodeConfig",
        );
        BuildGerarQrBarCodeModal(
          fields,
          modalGerarQrBarCodeConfig,
          saveGerarQrBarCodeConfig,
          element,
          bpmnFactory,
          extensionElements,
          businessObject,
          jsonObject,
        );
      },
    };

    entries.push(GerarQrBarCodeButton);
  }

  if (is(getBusinessObject(element), "bpmn:CallActivity")) {
    entries.push(
      entryFactory.checkbox(translate, {
        id: "callable-business-key",
        label: translate("Business Key"),
        modelProperty: "callableBusinessKey",

        get(element, node) {
          const camundaIn = getCamundaInWithBusinessKey(element);

          return {
            callableBusinessKey: !!(camundaIn && camundaIn.length > 0),
          };
        },

        set(element, values, node) {
          if (values.callableBusinessKey) {
            return setBusinessKey(
              element,
              "#{execution.processBusinessKey}",
              bpmnFactory,
            );
          }
          return deleteBusinessKey(element);
        },
      }),
    );
  }

  entries.push(
    entryFactory.textField(translate, {
      id: "business-key-expression",
      label: translate("Business Key Expression"),
      modelProperty: "businessKey",

      get(element, node) {
        const camundaInWithBusinessKey = getCamundaInWithBusinessKey(element);

        return {
          businessKey: camundaInWithBusinessKey.length
            ? camundaInWithBusinessKey[0].get("camunda:businessKey")
            : undefined,
        };
      },

      set(element, values, node) {
        const businessKey = values.businessKey;

        return setBusinessKey(element, businessKey, bpmnFactory);
      },

      validate(element, values, node) {
        const businessKey = values.businessKey;

        return businessKey === ""
          ? { businessKey: translate("Must provide a value") }
          : {};
      },

      hidden(element, node) {
        return !getCamundaInWithBusinessKey(element).length;
      },
    }),
  );

  entries = entries.concat(
    resultVariable(
      element,
      bpmnFactory,
      {
        id: "dmn-resultVariable",
        getBusinessObject,
        getImplementationType: getCallableType,
        hideResultVariable(element, node) {
          return getCallableType(element) !== "dmn";
        },
      },
      translate,
    ),
  );

  entries.push(
    entryFactory.selectBox(translate, {
      id: "dmn-map-decision-result",
      label: translate("Map Decision Result"),
      selectOptions: mapDecisionResultOptions,
      modelProperty: "mapDecisionResult",

      get(element, node) {
        const bo = getBusinessObject(element);
        return {
          mapDecisionResult:
            bo.get("camunda:mapDecisionResult") || "resultList",
        };
      },

      set(element, values, node) {
        return cmdHelper.updateProperties(element, {
          "camunda:mapDecisionResult": values.mapDecisionResult || "resultList",
        });
      },

      hidden(element, node) {
        const bo = getBusinessObject(element);
        const resultVariable = bo.get("camunda:resultVariable");
        return !(
          getCallableType(element) === "dmn" &&
          typeof resultVariable !== "undefined"
        );
      },
    }),
  );

  entries.push(
    entryFactory.selectBox(translate, {
      id: "delegateVariableMappingType",
      label: translate("Delegate Variable Mapping"),
      selectOptions: delegateVariableMappingOptions,
      emptyParameter: true,
      modelProperty: "delegateVariableMappingType",

      get(element, node) {
        return {
          delegateVariableMappingType: getDelegateVariableMappingType(element),
        };
      },

      set(element, values, node) {
        const delegateVariableMappingType = values.delegateVariableMappingType;

        const props = {
          "camunda:variableMappingClass": undefined,
          "camunda:variableMappingDelegateExpression": undefined,
        };

        if (delegateVariableMappingType === "variableMappingClass") {
          props["camunda:variableMappingClass"] = "";
        } else if (
          delegateVariableMappingType === "variableMappingDelegateExpression"
        ) {
          props["camunda:variableMappingDelegateExpression"] = "";
        }

        return cmdHelper.updateProperties(element, props);
      },

      hidden(element, node) {
        return getCallableType(element) !== "bpmn";
      },
    }),
  );

  entries.push(
    entryFactory.textField(translate, {
      id: "delegateVariableMapping",
      dataValueLabel: "delegateVariableMappingLabel",
      modelProperty: "delegateVariableMapping",

      get(element, node) {
        const bo = getBusinessObject(element);

        let label = "";
        let delegateVariableMapping = undefined;
        const type = getDelegateVariableMappingType(element);

        if (type === "variableMappingClass") {
          label = translate("Class");
          delegateVariableMapping = bo.get("camunda:variableMappingClass");
        } else if (type === "variableMappingDelegateExpression") {
          label = translate("Delegate Expression");
          delegateVariableMapping = bo.get(
            "camunda:variableMappingDelegateExpression",
          );
        }

        return {
          delegateVariableMapping,
          delegateVariableMappingLabel: label,
        };
      },

      set(element, values, node) {
        const delegateVariableMapping = values.delegateVariableMapping;

        const attr = "camunda:" + getDelegateVariableMappingType(element);

        const props = {};
        props[attr] = delegateVariableMapping || undefined;

        return cmdHelper.updateProperties(element, props);
      },

      validate(element, values, node) {
        const delegateVariableMapping = values.delegateVariableMapping;
        return (
          getCallableType(element) === "bpmn" &&
          (!delegateVariableMapping
            ? { delegateVariableMapping: translate("Must provide a value") }
            : {})
        );
      },

      hidden(element, node) {
        return !(
          getCallableType(element) === "bpmn" &&
          getDelegateVariableMappingType(element) !== ""
        );
      },
    }),
  );

  return entries;
}
